module.exports = __webpack_public_path__ + "static/media/heart.3756fa76.png";